import React from "react"
import { Roles } from "app/models/user"
import AccessRoles from "./AccessRoles"

type Props = {
  allowedRoles: Roles[]
}

export default function withAccessRoles<T extends {}>(Component: React.FC<T>) {
  return ({ allowedRoles, ...props }: Props & T) => (
    <AccessRoles allowedRoles={allowedRoles}>
      <Component {...((props as unknown) as T)} />
    </AccessRoles>
  )
}
